import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';

import { LinkDeviceWorkflow } from '../../devices/LinkDeviceWorkflow';

import AppleTvImage from '../../../images/device-appletv.png';
import CustomLink from '../../../components/CustomLink';

const useStyles = makeStyles((theme) => ({
  pageHeading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  deviceOverview: {
    paddingTop: 20,

    '& img': {
      width: '100%',
      height: 'auto'
    }
  },
  deviceImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export const AppleTvConnector = ({ screen, onCancel }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container>
      <Grid container>
        <Grid item xs={2}>
          <ArrowBack onClick={onCancel} />
        </Grid>
        <Grid item xs={8} className={classes.pageHeading}>
          {t('AppleTv.ConnectAppleTv')}
        </Grid>
        <Grid container item xs={12} className={classes.deviceOverview} spacing={2}>
          <Grid item xs={3} className={classes.deviceImage}>
            <img alt="Apple TV" src={AppleTvImage} />
          </Grid>
          <Grid item xs={9}>
            <Typography variant="h2">{t('AppleTv.GotAppleTvReady')}</Typography>
            <p>
              {t('AppleTv.Download')}{' '}
              <CustomLink href="https://apps.apple.com/us/app/id1397573295" target="_blank">
                {t('AppleTv.PourwallAppleTv')}
              </CustomLink>{' '}
              {t('AppleTv.App')}
            </p>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 20 }}>
          <LinkDeviceWorkflow screen={screen} />
        </Grid>
      </Grid>
    </Grid>
  );
};
